import React, { useState } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME } from "../../constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";

const alertStyle = {
  color: "red",
};

const AddInvestigation = () => {
  const [formData, setFormData] = useState({
    Product_Name: "",
    Product_Group: "",
    opd_amount: "",
    ipd_price: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formdata = new FormData();
    formdata.append("Product_Name", formData.Product_Name);
    formdata.append("Product_Group", formData.Product_Group);
    formdata.append("opd_amount", formData.opd_amount);
    formdata.append("ipd_price", formData.ipd_price);

    scAxiosAdmin
      .post("/investigations", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": `multipart/form-data; boundary=${formdata._boundary}`,
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      })
      .then(() => {
        toast.success("Investigation added successfully!");
        setFormData({
          Product_Name: "",
          Product_Group: "",
          opd_amount: "",
          ipd_price: "",
        });
      })
      .catch(() => {
        toast.error("Error adding investigation");
      });
  };

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="col-lg-12">
                <div className="card m-b-20">
                  <div className="card-body">
                    <h4 className="mt-0 header-title">Add Investigation</h4>
                    <form
                      onSubmit={handleSubmit}
                      id="editdepartmentform"
                      className="needs-validation"
                      noValidate
                    >
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Investigation Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="Product_Name"
                              value={formData.Product_Name}
                              onChange={handleChange}
                              required
                              placeholder="Investigation Name"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Investigation Group</label>
                            <input
                              type="text"
                              className="form-control"
                              name="Product_Group"
                              value={formData.Product_Group}
                              onChange={handleChange}
                              required
                              placeholder="Investigation Group"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Opd Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="opd_amount"
                              value={formData.opd_amount}
                              onChange={handleChange}
                              required
                              placeholder="Opd Amount"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Ipd Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="ipd_price"
                              value={formData.ipd_price}
                              onChange={handleChange}
                              required
                              placeholder="Ipd Amount"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <div>
                          <button
                            type="submit"
                            className="btn btn-pink waves-effect waves-light"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default AddInvestigation;



// WEBPACK FOOTER //
// ./src/component/admin/AddInvestigation.js